import DropFile from './upload-file'

export default DropFile
